import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import igbusinessLocales from '../../locales/igbusiness.json';
import igbusinessTemplatesLocales from '../../locales/igbusiness_templates.json';
import boardsLocales from '../../locales/board.json';
import bmcLocales from '../../locales/bmc.json';
import defaultLocales from '../../locales/default.json';
import RootStore from './stores/RootStore';
import BlockUi from '../common_components/BlockUi';
import NewActivity from './NewActivity';
import ActivityShow from './ActivityShow';
import { Provider, observer, inject } from 'mobx-react';
import FinalStep from './FinalStep';
import Index from './Index';
import ActivityEdit from './ActivityEdit';
import Header from './header';
import { Row, Col } from 'react-bootstrap';
// import {AUTH_EDIT, AUTH_SHOW} from './authorization';
import MainApp from './MainApp';

addLocaleData([...es, ...en]);

import MainTooltips from '../common_components/tooltips/MainTooltips';
import TooltipStore from '../common_components/tooltips/TooltipStore';
import { TOOLTIPPROPS } from './constantsTooltips';
import { BUSINESS_ROUTE_PATH } from './constants.js';

@inject('isPremium')
@observer
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.rootStore = new RootStore(props);
    this.authorizationStore = this.rootStore.authorizationStore;

    this.tooltipStore = new TooltipStore(this.rootStore, TOOLTIPPROPS);
    this.rootStore.tooltipStore = this.tooltipStore;

    this.state = { emptyCurrentMVP: false };

    const { userLocale } = props;

    const messages = {
      ...igbusinessLocales[userLocale],
      ...boardsLocales[userLocale],
      ...defaultLocales[userLocale],
      ...igbusinessTemplatesLocales[userLocale],
      ...bmcLocales[userLocale]
    };

    const intlProvider = new IntlProvider({ locale: userLocale, messages }, {});
    const intl = intlProvider.getChildContext().intl;

    this.rootStore.localeStore = { intl, messages };
  }

  render() {
    return (
      <Provider
        rootStore={this.rootStore}
        authorizationStore={this.authorizationStore}
      >
        <IntlProvider
          locale={this.rootStore.localeStore.intl.locale}
          messages={this.rootStore.localeStore.messages}
        >
          <div className="">
            <MainTooltips
              customJoyrideProps={{
                scrollToFirstStep: false
              }}
            />
            <BlockUi blocking={!this.props.isPremium}>
              <div className="igbusiness">
                <Switch>
                  <Route
                    path={BUSINESS_ROUTE_PATH}
                    render={p => (
                      <MainApp
                        emptyCurrentMVP={this.state.emptyCurrentMVP}
                        {...p}
                      />
                    )}
                  />
                </Switch>
                <br />
              </div>
            </BlockUi>
          </div>
        </IntlProvider>
      </Provider>
    );
  }

  componentDidMount() {
    if (this.props.currentBoardId !== null) {
      this.rootStore.igBusinessStore.initStore(
        this.props.visionBoardId,
        this.props.currentBoardId
      );
    } else {
      this.setState({ emptyCurrentMVP: true });
    }
  }
}
